<div class="flex flex-row">
  <h2 class="page-header">Zoek</h2>
  <button
    mat-flat-button
    class="action-button"
    style="margin: 20px"
    [routerLink]="['/project/nieuw/0']"
  >
    + Nieuw project
  </button>
  <button
    mat-flat-button
    class="action-button"
    style="margin: 20px 20px 20px 0"
    [routerLink]="[getRouterLinkCreateOldSystemProject()]"
  >
    + Uit oud systeem
  </button>
</div>
<mat-checkbox
  [(ngModel)]="includeRepo"
  (ngModelChange)="reloadData.emit()"
  [disabled]="true"
  >Inclusief afgehaalde projecten</mat-checkbox
>
<div class="table-container panel">
  <div class="example-table-container">
    <div *ngIf="loading" class="table-loader-overlay" style="margin-top: 55px;">
      <div style="margin-top: 145px; align-self: center">
        <mat-spinner
          style="margin:auto;"
          color="primary"
          diameter="75"
        ></mat-spinner>
      </div>
    </div>
    <table
      mat-table
      [dataSource]="projects"
      class="example-table"
      matSort
      matSortActive="project_id"
      matSortDisableClear="true"
      matSortDirection="asc"
    >
      <ng-container matColumnDef="project_id">
        <th mat-header-cell *matHeaderCellDef class="header-text">
          <div class="d-flex">
            <div class="text-middle" [mat-sort-header]="">
              <b>#</b>
            </div>
            <filter-input
              [filterObject]="getFilterForKey('project__id')"
              (click)="$event.preventDefault() && $event.stopPropagation()"
              (toggleFilterEmitter)="toggleFilter($event)"
              (filterValueChanged)="onFilterValueChange($event)"
            ></filter-input>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="table-text"
          [routerLink]="['/project', row.project.id, row.id]"
        >
          <span>#{{ row.project.id }}</span>
          <span
            *ngIf="row.project.oldPlatformId != null"
            class="font-weight-bold font-italic"
            [matTooltip]="'Jobnummer oud platform'"
          >
            ({{ row.project.oldPlatformId }})</span
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef class="header-text">
          <div class="d-flex">
            <div class="text-middle extra-right">
              <b>Klant</b>
            </div>
            <filter-input
              [filterObject]="
                getFilterForKey(
                  'project__projectContacts__company__regularName'
                )
              "
              (click)="$event.preventDefault() && $event.stopPropagation()"
              (toggleFilterEmitter)="toggleFilter($event)"
              (filterValueChanged)="onFilterValueChange($event)"
            ></filter-input>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="table-text"
          [routerLink]="['/project', row.project.id, row.id]"
        >
          <div
            *ngFor="
              let c of row.project.involvedCompanies;
              let isLast = last;
              trackBy: trackById
            "
          >
            <span matTooltip="{{ c.regularName }}">{{ c.regularName }}</span>
            <span *ngIf="!c.dataCorrect"
              >&nbsp;&nbsp;
              <mat-icon
                matTooltip="Bedrijf nog niet vervolledigd"
                class="data-not-correct-icon"
                >report_problem</mat-icon
              >
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="projectPlacement.address">
        <th class="header-text" mat-header-cell *matHeaderCellDef>
          <div class="d-flex">
            <div class="text-middle" mat-sort-header>
              <b>Adres</b>
            </div>
            <filter-input
              [filterObject]="getFilterForKey('projectPlacement__address')"
              (click)="$event.preventDefault() && $event.stopPropagation()"
              (toggleFilterEmitter)="toggleFilter($event)"
              (filterValueChanged)="onFilterValueChange($event)"
            ></filter-input>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="table-text"
          [routerLink]="['/project', row.project.id, row.id]"
        >
          <div *ngIf="row.projectPlacement?.address">
            {{
              row.projectPlacement?.address?.line1
                | printAddress
                  : row.projectPlacement?.address?.postalCode
                  : row.projectPlacement?.address?.city
            }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="productType">
        <th mat-header-cell *matHeaderCellDef class="header-text">
          <div class="d-flex">
            <div class="text-middle">
              <b>Type(s)</b>
            </div>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="table-text"
          [routerLink]="['/project', row.project.id, row.id]"
        >
          <div
            class="line-height in-the-middle-left"
            *ngFor="
              let prod of row.project.products;
              let isLast = last;
              trackBy: trackById
            "
            [matTooltip]="prod.type | productType: prod.otherProductName"
          >
            {{ prod.type | abbreviatedProductType: prod.otherProductName }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="boardTypeAndPlacement">
        <th mat-header-cell *matHeaderCellDef class="header-text">
          <b>Type bord</b>
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="table-text"
          (click)="openProject(row)"
        >
          <div
            class="line-height in-the-middle-left"
            *ngFor="
              let prod of row.project.products;
              let isLast = last;
              trackBy: trackById
            "
          >
            {{
              prod.boardType
                | joiner: ' - ':prod.placementType
                | shortenText: 32
            }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="displayStatus">
        <th mat-header-cell *matHeaderCellDef class="header-text"></th>
        <td
          mat-cell
          *matCellDef="let row"
          class="table-text"
          [routerLink]="['/project', row.project.id, row.id]"
        >
          <span [ngClass]="getStatusString(row).toLowerCase()" class="status">
            {{ getType(row) }}
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        class="table-row"
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
    </table>
  </div>

  <div *ngIf="projects.length === 0" class="no-result-text">
    <div>Geen resultaten gevonden</div>
  </div>

  <mat-paginator
    [length]="totalItems"
    [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="true"
  ></mat-paginator>
</div>
